'use client';
import EditorLink from 'lowcode/components/EditorLink';

export default function Content({ id, data = {}, index = 0 }: any) {
    const { link, title, titleH5, desc, descH5, titleColor, bgColor } = data;

    return (
        <>
            <EditorLink
                className={`glo-bar-item glo-bar-item-${index} glo-bar-padding glo-bar-type-text`}
                href={link}
                style={{
                    background: bgColor || null,
                }}
            >
                <div className="glo-bar-text-box">
                    {title && (
                        <div
                            className="glo-bar-title pc"
                            style={{
                                color: titleColor || null,
                            }}
                        >
                            {title}
                        </div>
                    )}
                    {(titleH5 || title) && (
                        <div
                            className="glo-bar-title h5"
                            style={{
                                color: titleColor || null,
                            }}
                        >
                            {titleH5 || title}
                        </div>
                    )}
                    {desc && (
                        <div
                            className="glo-bar-desc pc"
                            style={{
                                color: titleColor || null,
                            }}
                        >
                            {desc}
                        </div>
                    )}
                    {(descH5 || desc) && (
                        <div
                            className="glo-bar-desc h5"
                            style={{
                                color: titleColor || null,
                            }}
                        >
                            {descH5 || desc}
                        </div>
                    )}
                </div>
            </EditorLink>
        </>
    );
}
